module.exports = __webpack_public_path__ + "static/media/favicon.c50df950.ico";